// extracted by mini-css-extract-plugin
module.exports = {"chain":"select-chain_chain__1wtEl","body":"select-chain_body__LWECD","bodyButton":"select-chain_bodyButton__3I4C0","bodyIcon":"select-chain_bodyIcon__3GLq9"};